define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/utility/pathUtility",
], function(declare, Ref, {pathCreate}) {

	return declare(Ref, {
		bCopy: true,
		onlyCopyToEmpty: true,

		/**
		 * @override
		 * Drag-fill logic requires dependency paths
		 */
		addRendererDependencyPaths: function(h, paths) {
			paths.push(pathCreate("Theme", "__Parent__"));
		},

		/**
		 * @override
		 * Only allow drag-fill if existing Theme is active
		 */
		canCopy(ctxCopy, h) {
			const {cache} = ctxCopy;
			const theme = cache.get(ctxCopy.getNode().Theme);
			const themeMaster = cache.getNode(theme?.__Parent__);
			return !!themeMaster?.Active && this.inherited(arguments);
		},
	});
});